import { HTMLAttributes } from 'react';
import { CopyButton } from 'components';
import * as S from './styles';

interface Props extends HTMLAttributes<HTMLDivElement> {
  copyContent?: string;
}

export function CopyContent({ children, copyContent }: Props) {
  return (
    <S.CopyWrapper>
      <S.CopyButtonWrapper>
        {copyContent && <CopyButton content={copyContent} />}
      </S.CopyButtonWrapper>

      <S.TextWrapper>{children}</S.TextWrapper>
    </S.CopyWrapper>
  );
}
